import { AppType } from '../../constants/AppType';
import Applications from '../../components/Applications/Applications';
import withHasPermission from '../../hoc/withHasPermission';
import { Permission } from '../../permissions/permission';

export const ScheduledTasks = withHasPermission(() => {
    return <Applications type={AppType.ScheduledTask} title={'Scheduled Tasks'} icon={'fa fa-clock'} />;
}, Permission.Root_ScheduledTasks);
